import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import Icon from "@mui/material/Icon";
import { UpdateIntegrationDialog } from "cxfcomponents/Integrations/UpdateIntegrationDialog";
import { useState } from "react";
import { useIntegrationPermissions } from "hooks/useIntegrationPermissions";

export const IntegrationOptions = ({ integration }) => {
  const [isPropertiesOpen, setIsPropertiesOpen] = useState(false);
  const { canEdit } = useIntegrationPermissions(integration);

  return (
    <>
      <SoftBox display="flex" sx={{ marginTop: "auto" }}>
        <SoftButton
          sx={{
            margin: "0 20px 0 0",
            padding: "12px !important"
          }}
          variant="gradient"
          size="medium"
          color="primary"
          onClick={() => setIsPropertiesOpen(true)}
          disabled={!canEdit}
        >
          <Icon sx={{ marginRight: "8px" }}>edit</Icon>
          properties
        </SoftButton>
      </SoftBox>
      <UpdateIntegrationDialog
        open={isPropertiesOpen}
        onClose={() => setIsPropertiesOpen(false)}
        integration={integration}
      />
    </>
  );
};
